import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const SalesIcon = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
  "data-test-id": "vertical-nav-icon__content"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "M29,1.98H3.02c-.55,0-1,.45-1,1v8.67c0,.55.45,1,1,1h.96v7.67c0,.55.45,1,1,1h.96v7.67c0,.55.45,1,1,1h18.14c.55,0,1-.45,1-1v-7.67h.96c.55,0,1-.45,1-1v-7.67h.96c.55,0,1-.45,1-1V2.98c0-.55-.45-1-1-1ZM4.02,3.98h23.97v6.67H4.02V3.98ZM24.08,27.98H7.94v-6.67h16.14v6.67ZM26.04,19.32H5.98v-6.67h20.06v6.67Z"
  })
}));
export default SalesIcon;